import "./ToggleSwitch.css";

function ToggleSwitch({ checked, onChange }) {
  return (
    <label className="label">
      <div className={`toggle ${checked ? "toggle-active" : ""}`}>
        <input
          className="toggle-state"
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />
        <div className="indicator"></div>
      </div>
    </label>
  );
}

export default ToggleSwitch;